import axios from 'axios'
import CreateDepartment from './dto/CreateDepartment'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedDepartmentResultRequestDto} from './dto/PagedDepartmentResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllDepartments from './dto/GetAllDepartments'
import UpdateDepartment from './dto/UpdateDepartment'
import GetDepartment from './dto/GetDepartment'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Department/Create`
export const URL_DELETE = `${API_URL}/Department/Delete`
export const URL_GET = `${API_URL}/Department/Get`
export const URL_GET_ALL = `${API_URL}/Department/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Department/Update`

export function onCreateDepartment(createDepartment: CreateDepartment): Promise<boolean> {
  return axios.post(URL_CREATE, createDepartment)
}

export function onDeleteDepartment(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetDepartment(entityDto: EntityDto): Promise<GetDepartment> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllDepartments(
  pagedFilterAndSortedRequest: PagedDepartmentResultRequestDto
): Promise<PagedResultDto<GetAllDepartments>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateDepartment(updateDepartmentInput: UpdateDepartment): Promise<boolean> {
  return axios.put(URL_UPDATE, updateDepartmentInput)
}
